const t = {
  en: {
    appName:   'DailyRaashi',
    tagline:   'Your stars. Your day.',
    getReading: 'Get My Reading',

    signUp:   'Sign Up',
    logIn:    'Log In',
    name:     'Full Name',
    email:    'Email',
    password: 'Password',
    continueGoogle: 'Continue with Google',
    alreadyAccount: 'Already have an account?',
    newHere:        'New here? ',
    orLabel:        'or',
    authError:      'Authentication failed. Please try again.',
    passwordWeak:   'Weak',
    passwordMedium: 'Medium',
    passwordStrong: 'Strong',
    passwordHint:   'Min 8 characters with a number and special character',

    birthDetailsTitle:    'Your Birth Details',
    birthDetailsSubtitle: 'We use this once to build your eternal chart',
    dateOfBirth:  'Date of Birth',
    timeOfBirth:  'Time of Birth (optional)',
    placeOfBirth: 'Place of Birth',
    searchCity:   'Type your birth city…',
    generateChart: 'Generate My Chart',
    noTimeHint:    'Add time for most accurate chart',

    readingStars:   'Reading the stars for you…',
    buildingChart:  'Building your eternal birth chart',

    todaysReading:  "Today's Reading",
    revealReading:  "Reveal Today's Reading",
    yourChart:      'Your Birth Chart',
    sunSign:        'Sun Sign',
    moonSign:       'Moon Sign',
    ascendant:      'Ascendant',

    cosmicAlarmTitle:       'Cosmic Alarm',
    cosmicAlarmPrompt:      'Set a daily reminder to check your Jyotish reading.',
    cosmicAlarmExplain:     'Jyoti will remind you each morning to read your personalised cosmic guidance.',
    setAlarm:  'Set Alarm',
    skipAlarm: 'Skip for Now',
    alarmSet:  'Cosmic alarm set for',

    colorToday:   'Your Colour Today',
    foodToday:    'What to Eat Today',
    routineToday: 'Your Rhythm Today',
    eatThese:     'Favour These',
    avoidThese:   'Avoid These',
    morning:      'Morning (Sunrise – 10am)',
    afternoon:    'Afternoon (10am – 4pm)',
    evening:      'Evening (4pm – Sunset)',
    clothingTip:  'Clothing Tip',

    jyotisNote:      'A Note from Jyoti',
    todaysRemedy:    "Today's Remedy",
    remedyTitle:     'Remedy',
    remedyTiming:    'When to perform',
    cosmicWisdom:    'Cosmic Wisdom',
    dashaInfo:       'Your Cosmic Period',
    moonTransit:     'Moon Transit',
    readingDisclaimer: 'DailyRaashi readings are for spiritual guidance and entertainment purposes only. Not a substitute for professional medical, legal, or financial advice.',

    unlockStars:      'Unlock Your Stars',
    trialEnded:       'Your 30-day free trial has ended',
    trialActive:      '30-day free trial included',
    monthlyPlan:      'Monthly',
    yearlyPlan:       'Yearly',
    yearlyPrice:      '₹499 / year',
    monthlyPrice:     '₹49 / month',
    saveLabel:        'Save ₹89',
    subscribeNow:     'Subscribe Now',
    bestValue:        'Best Value',
    paymentFailed:    'Payment failed. Please try again.',
    howJyotiWorks:    'How Jyoti Works',

    settings:           'Settings',
    languagePref:       'Language',
    birthTimeSetting:   'Birth Time',
    cosmicAlarmSetting: 'Cosmic Alarm Time',
    saveChanges:        'Save Changes',
    lockedField:        'Contact support to update',
    birthDateLocked:    'Birth Date (locked)',
    birthCityLocked:    'Birth City (locked)',
    saved:              'Settings saved!',
    logOut:             'Log Out',

    noTimeMessage:      'For the most accurate reading, add your birth time in Settings.',
    loading:            'Loading…',
    generatingReading:  'Jyoti is reading your stars…',
    readingDate:        'Reading for',

    viewPlanets:  'View Planet Positions',
    hidePlanets:  'Hide Planets',
    planet:       'Planet',
    sign:         'Sign',
    house:        'House',

    shareReading:     "Share Today's Reading",
    shareCardTitle:   'Share',
    shareCardDesc:    'Share or save your reading card',
    shareBtn:         'Share via…',
    saveBtn:          'Save Image',
    generatingCard:   'Generating your card…',
    todaysColour:     "Today's Colour",
    favourToday:      'Favour Today',
    morningGuidance:  'Morning Guidance',

    setLocation:        'Set Your Location',
    locationSubtitle:   'For accurate Muhurtas & Chaughadiyas',
    useMyLocation:      'Use My Location',
    enterCity:          'Enter City',
    locationSet:        'Location set',
    locationSkip:       'Skip for now',
    detectingLocation:  'Detecting location…',

    muhurtasTitle:      'Today\'s Muhurtas',
    brahmaMuhurta:      'Brahma Muhurta',
    abhijitMuhurta:     'Abhijit Muhurta',
    rahuKaal:           'Rahu Kaal',
    chaughadiya:        'Chaughadiya',
    dayChaughadiya:     'Day',
    nightChaughadiya:   'Night',
    currentPeriod:      'Now',
    excellent:          'Excellent',
    good:               'Auspicious',
    neutral:            'Neutral',
    avoid:              'Avoid',
    sunrise:            'Sunrise',
    sunset:             'Sunset',

    privacyPolicy:    'Privacy Policy',
    disclaimer:       'Disclaimer',

    gender:         'Gender (optional)',
    male:           'Male',
    female:         'Female',
    other:          'Other / Prefer not to say',
    termsAgree:     'I agree to the',
    termsLink:      'Terms & Privacy Policy',
    termsRequired:  'Please accept the terms to continue.',

    phoneTab:       'Phone',
    emailTab:       'Email',
    phoneNumber:    'Phone Number (+91...)',
    sendOtp:        'Send OTP',
    verifyOtp:      'Verify OTP',
    enterOtp:       'Enter 6-digit OTP',
    otpSent:        'OTP sent to',
    resendOtp:      'Resend OTP',
    changePhone:    'Change Number',

    subscriptionStatus:  'Subscription',
    planTrial:           'Free Trial',
    planMonthly:         'Monthly Plan',
    planYearly:          'Yearly Plan',
    planExpired:         'Expired',
    trialDaysLeft:       'days remaining',
    expiresOn:           'Expires',
    upgradePlan:         'Upgrade Plan',
    manageSubscription:  'Manage Subscription',

    cosmicSnapshot:        'Sky Right Now',
    cosmicSnapshotSubtitle: "Today's planetary positions",
    planetSign:            'in',

    babyNames:           'Vedic Baby Names',
    babyNamesSubtitle:   'Names aligned with your child\'s birth nakshatra',
    babyBirthDate:       'Baby\'s Birth Date',
    babyBirthTime:       'Baby\'s Birth Time (optional)',
    babyBirthCity:       'Baby\'s Birth City',
    babyGender:          'Baby\'s Gender',
    generateNames:       'Suggest Vedic Names',
    generatingNames:     'Consulting the stars…',
    nakshatraResult:     'Birth Nakshatra',
    suggestedNames:      'Suggested Names',
    nameMeaning:         'Meaning',
    nameOrigin:          'Origin',

    adminLogin:      'Admin Login',
    adminPassword:   'Admin Password',
    adminEnter:      'Enter Admin Panel',
    adminDashboard:  'Dashboard',
    adminUsers:      'Users',
    adminPromos:     'Promo Codes',
    totalUsers:      'Total Users',
    trialActive:     'Trial Active',
    subscribed:      'Subscribed',
    totalReadings:   'Readings',
    searchUsers:     'Search users…',
    grantDays:       'Grant Days',
    grantSubscription: 'Grant Subscription',
    days:            'days',
    grant:           'Grant',
    createPromo:     'Create Promo Code',
    promoCode:       'Promo Code',
    promoType:       'Type',
    promoTypePercent: '% Discount',
    promoTypeDays:   'Free Days',
    promoValue:      'Value',
    promoMaxUses:    'Max Uses',
    promoExpiry:     'Expiry Date',
    promoCreate:     'Create',
    promoDelete:     'Deactivate',
    noPromos:        'No promo codes yet.',
    adminLogout:     'Logout',

    pricingTitle:    'Choose Your Plan',
    pricingSubtitle: 'Unlock personalised Vedic guidance daily',

    luckyNumber:          "Today's Lucky Number",
    luckyNumberSubtitle:  'Numerology · Vedic',
    luckyPlanet:          'Ruling Planet',
    luckyDirection:       'Direction',
    luckyMantra:          'Mantra',
    shareNumber:          'Share My Number',

    readingHistory:        'Reading History',
    readingHistorySubtitle: 'Your past 7 daily readings',

    familyTitle:       'Family Members',
    familySubtitle:    'Charts & daily readings for your loved ones',
    addMember:         'Add Member',
    noFamilyMembers:   'No family members yet',
    noFamilyHint:      'Add your loved ones to get personalised Jyotish readings for them',
    familyReading:     'View Reading',

    myChart:           'My Chart',
    birthNakshatra:    'Birth Star (Nakshatra)',
    nakshatraDeity:    'Deity',
    nakshatraLord:     'Lord',
    dashaTitle:        'Current Cosmic Period',
    mahadasha:         'Mahadasha',
    antardasha:        'Antardasha',
    dashaEnds:         'Ends',
    currentSky:        'Sky Right Now',
    birthDetailsCard:  'Birth Details',
    unknownTime:       "I don't know my birth time",
    noBirthTime:       'Time unknown',

    navHome:           'Home',
    navReading:        'Reading',
    navChart:          'My Chart',
    navProfile:        'Profile',

    hi: 'हिं',
    en: 'En',
  },
  hi: {
    appName:   'डेलीराशि',
    tagline:   'आपके सितारे। आपका दिन।',
    getReading: 'मेरी राशि देखें',

    signUp:   'साइन अप करें',
    logIn:    'लॉग इन करें',
    name:     'पूरा नाम',
    email:    'ईमेल',
    password: 'पासवर्ड',
    continueGoogle: 'Google से जारी रखें',
    alreadyAccount: 'पहले से खाता है?',
    newHere:        'नए हैं? ',
    orLabel:        'या',
    authError:      'प्रमाणीकरण विफल। कृपया पुनः प्रयास करें।',
    passwordWeak:   'कमज़ोर',
    passwordMedium: 'मध्यम',
    passwordStrong: 'मज़बूत',
    passwordHint:   'न्यूनतम 8 अक्षर, एक अंक और एक विशेष वर्ण',

    birthDetailsTitle:    'आपका जन्म विवरण',
    birthDetailsSubtitle: 'हम इसे एक बार आपकी जन्म कुंडली बनाने के लिए उपयोग करते हैं',
    dateOfBirth:  'जन्म तिथि',
    timeOfBirth:  'जन्म समय (वैकल्पिक)',
    placeOfBirth: 'जन्म स्थान',
    searchCity:   'अपना जन्म शहर टाइप करें…',
    generateChart: 'मेरी कुंडली बनाएं',
    noTimeHint:    'सटीक कुंडली के लिए समय जोड़ें',

    readingStars:   'आपके लिए सितारे पढ़े जा रहे हैं…',
    buildingChart:  'आपकी जन्म कुंडली बनाई जा रही है',

    todaysReading:  'आज की राशि',
    revealReading:  'आज की राशि देखें',
    yourChart:      'आपकी जन्म कुंडली',
    sunSign:        'सूर्य राशि',
    moonSign:       'चंद्र राशि',
    ascendant:      'लग्न',

    cosmicAlarmTitle:       'कोस्मिक अलार्म',
    cosmicAlarmPrompt:      'अपनी दैनिक ज्योतिष राशि की याद के लिए अलार्म सेट करें।',
    cosmicAlarmExplain:     'ज्योति आपको प्रत्येक सुबह अपनी व्यक्तिगत कोस्मिक मार्गदर्शन पढ़ने की याद दिलाएगी।',
    setAlarm:  'अलार्म सेट करें',
    skipAlarm: 'अभी छोड़ें',
    alarmSet:  'कोस्मिक अलार्म सेट हो गया',

    colorToday:   'आज का रंग',
    foodToday:    'आज का आहार',
    routineToday: 'आज की दिनचर्या',
    eatThese:     'ये खाएं',
    avoidThese:   'ये न खाएं',
    morning:      'सुबह (सूर्योदय – सुबह 10 बजे)',
    afternoon:    'दोपहर (10 बजे – शाम 4 बजे)',
    evening:      'शाम (शाम 4 बजे – सूर्यास्त)',
    clothingTip:  'वस्त्र सुझाव',

    jyotisNote:      'ज्योति का संदेश',
    todaysRemedy:    'आज का उपाय',
    remedyTitle:     'उपाय',
    remedyTiming:    'कब करें',
    cosmicWisdom:    'ज्योतिष ज्ञान',
    dashaInfo:       'आपका दशा काल',
    moonTransit:     'चंद्र गोचर',
    readingDisclaimer: 'डेलीराशि की राशिफल आध्यात्मिक मार्गदर्शन और मनोरंजन के लिए है। यह पेशेवर चिकित्सा, कानूनी या वित्तीय सलाह का विकल्प नहीं है।',

    unlockStars:      'अपने सितारे अनलॉक करें',
    trialEnded:       'आपका 30 दिन का मुफ्त परीक्षण समाप्त हो गया',
    trialActive:      '30 दिन का मुफ्त परीक्षण शामिल',
    monthlyPlan:      'मासिक',
    yearlyPlan:       'वार्षिक',
    yearlyPrice:      '₹499 / वर्ष',
    monthlyPrice:     '₹49 / माह',
    saveLabel:        '₹89 की बचत',
    subscribeNow:     'अभी सदस्यता लें',
    bestValue:        'सर्वश्रेष्ठ मूल्य',
    paymentFailed:    'भुगतान विफल। कृपया पुनः प्रयास करें।',
    howJyotiWorks:    'ज्योति कैसे काम करती है',

    settings:           'सेटिंग्स',
    languagePref:       'भाषा',
    birthTimeSetting:   'जन्म समय',
    cosmicAlarmSetting: 'कोस्मिक अलार्म समय',
    saveChanges:        'परिवर्तन सहेजें',
    lockedField:        'अपडेट के लिए सहायता से संपर्क करें',
    birthDateLocked:    'जन्म तिथि (लॉक)',
    birthCityLocked:    'जन्म शहर (लॉक)',
    saved:              'सेटिंग्स सहेजी गईं!',
    logOut:             'लॉग आउट',

    noTimeMessage:      'सटीक राशिफल के लिए सेटिंग्स में जन्म समय जोड़ें।',
    loading:            'लोड हो रहा है…',
    generatingReading:  'ज्योति आपके सितारे पढ़ रही है…',
    readingDate:        'राशिफल',

    viewPlanets:  'ग्रहों की स्थिति देखें',
    hidePlanets:  'छुपाएं',
    planet:       'ग्रह',
    sign:         'राशि',
    house:        'भाव',

    shareReading:     'आज की राशि शेयर करें',
    shareCardTitle:   'शेयर',
    shareCardDesc:    'अपनी राशि कार्ड शेयर या सहेजें',
    shareBtn:         'शेयर करें',
    saveBtn:          'चित्र सहेजें',
    generatingCard:   'कार्ड बन रहा है…',
    todaysColour:     'आज का रंग',
    favourToday:      'आज यह खाएं',
    morningGuidance:  'सुबह की दिनचर्या',

    setLocation:        'अपना स्थान सेट करें',
    locationSubtitle:   'मुहूर्त और चौघड़िया के लिए',
    useMyLocation:      'मेरा स्थान उपयोग करें',
    enterCity:          'शहर दर्ज करें',
    locationSet:        'स्थान सेट हो गया',
    locationSkip:       'अभी छोड़ें',
    detectingLocation:  'स्थान पहचाना जा रहा है…',

    muhurtasTitle:      'आज के मुहूर्त',
    brahmaMuhurta:      'ब्रह्म मुहूर्त',
    abhijitMuhurta:     'अभिजित मुहूर्त',
    rahuKaal:           'राहु काल',
    chaughadiya:        'चौघड़िया',
    dayChaughadiya:     'दिन',
    nightChaughadiya:   'रात',
    currentPeriod:      'अभी',
    excellent:          'श्रेष्ठ',
    good:               'शुभ',
    neutral:            'सामान्य',
    avoid:              'टालें',
    sunrise:            'सूर्योदय',
    sunset:             'सूर्यास्त',

    privacyPolicy:    'गोपनीयता नीति',
    disclaimer:       'अस्वीकरण',

    gender:         'लिंग (वैकल्पिक)',
    male:           'पुरुष',
    female:         'महिला',
    other:          'अन्य',
    termsAgree:     'मैं स्वीकार करता/करती हूं',
    termsLink:      'नियम और गोपनीयता नीति',
    termsRequired:  'जारी रखने के लिए नियम स्वीकार करें।',

    phoneTab:       'फोन',
    emailTab:       'ईमेल',
    phoneNumber:    'फोन नंबर (+91...)',
    sendOtp:        'OTP भेजें',
    verifyOtp:      'OTP सत्यापित करें',
    enterOtp:       '6 अंकों का OTP दर्ज करें',
    otpSent:        'OTP भेजा गया',
    resendOtp:      'OTP पुनः भेजें',
    changePhone:    'नंबर बदलें',

    subscriptionStatus:  'सदस्यता',
    planTrial:           'निःशुल्क परीक्षण',
    planMonthly:         'मासिक योजना',
    planYearly:          'वार्षिक योजना',
    planExpired:         'समाप्त',
    trialDaysLeft:       'दिन शेष',
    expiresOn:           'समाप्ति',
    upgradePlan:         'अपग्रेड करें',
    manageSubscription:  'सदस्यता प्रबंधित करें',

    cosmicSnapshot:        'अभी का आकाश',
    cosmicSnapshotSubtitle: 'आज की ग्रह स्थितियां',
    planetSign:            'में',

    babyNames:           'वैदिक शिशु नाम',
    babyNamesSubtitle:   'नक्षत्र के अनुसार नाम',
    babyBirthDate:       'जन्म तिथि',
    babyBirthTime:       'जन्म समय (वैकल्पिक)',
    babyBirthCity:       'जन्म शहर',
    babyGender:          'लिंग',
    generateNames:       'वैदिक नाम सुझाएं',
    generatingNames:     'सितारों से पूछ रहे हैं…',
    nakshatraResult:     'जन्म नक्षत्र',
    suggestedNames:      'सुझाए गए नाम',
    nameMeaning:         'अर्थ',
    nameOrigin:          'उत्पत्ति',

    adminLogin:      'एडमिन लॉगिन',
    adminPassword:   'एडमिन पासवर्ड',
    adminEnter:      'एडमिन पैनल खोलें',
    adminDashboard:  'डैशबोर्ड',
    adminUsers:      'उपयोगकर्ता',
    adminPromos:     'प्रोमो कोड',
    totalUsers:      'कुल उपयोगकर्ता',
    trialActive:     'परीक्षण सक्रिय',
    subscribed:      'सदस्य',
    totalReadings:   'राशिफल',
    searchUsers:     'उपयोगकर्ता खोजें…',
    grantDays:       'दिन दें',
    grantSubscription: 'सदस्यता दें',
    days:            'दिन',
    grant:           'दें',
    createPromo:     'प्रोमो कोड बनाएं',
    promoCode:       'प्रोमो कोड',
    promoType:       'प्रकार',
    promoTypePercent: '% छूट',
    promoTypeDays:   'मुफ्त दिन',
    promoValue:      'मूल्य',
    promoMaxUses:    'अधिकतम उपयोग',
    promoExpiry:     'समाप्ति तिथि',
    promoCreate:     'बनाएं',
    promoDelete:     'निष्क्रिय करें',
    noPromos:        'अभी कोई प्रोमो कोड नहीं।',
    adminLogout:     'लॉगआउट',

    pricingTitle:    'अपनी योजना चुनें',
    pricingSubtitle: 'दैनिक वैदिक मार्गदर्शन अनलॉक करें',

    luckyNumber:          'आज का शुभ अंक',
    luckyNumberSubtitle:  'अंक ज्योतिष · वैदिक',
    luckyPlanet:          'स्वामी ग्रह',
    luckyDirection:       'दिशा',
    luckyMantra:          'मंत्र',
    shareNumber:          'अपना अंक शेयर करें',

    readingHistory:        'राशिफल इतिहास',
    readingHistorySubtitle: 'पिछले 7 दिनों की राशिफल',

    familyTitle:       'परिवार के सदस्य',
    familySubtitle:    'अपने प्रियजनों की कुंडली और राशिफल',
    addMember:         'सदस्य जोड़ें',
    noFamilyMembers:   'अभी कोई परिवार सदस्य नहीं',
    noFamilyHint:      'अपने प्रियजनों को जोड़ें और उनकी राशिफल पाएं',
    familyReading:     'राशिफल देखें',

    myChart:           'मेरा चार्ट',
    birthNakshatra:    'जन्म नक्षत्र',
    nakshatraDeity:    'देवता',
    nakshatraLord:     'स्वामी',
    dashaTitle:        'वर्तमान दशा काल',
    mahadasha:         'महादशा',
    antardasha:        'अंतर्दशा',
    dashaEnds:         'समाप्त',
    currentSky:        'अभी का आकाश',
    birthDetailsCard:  'जन्म विवरण',
    unknownTime:       'जन्म समय नहीं पता',
    noBirthTime:       'समय अज्ञात',

    navHome:           'होम',
    navReading:        'राशिफल',
    navChart:          'मेरा चार्ट',
    navProfile:        'प्रोफ़ाइल',

    hi: 'हिं',
    en: 'En',
  },
};

export default t;
